

export const Loading = () => (
  <div className='wrapper' style={{ marginTop: "15rem" }}>
    <div
      className="loader"
      style={{
        width: "5em",
        height: "5em",
        animation: "spin 800ms infinite linear"
      }}
    />
  </div>
)